$(document).ready(() => {
    // Запрос по REST количество активностей для соц сетей
    fetch(HH.site_url + '/wp-json/hh/social-rest-api/v1/social-stats/' + HH.post_id)
        .then((response) =>  {
            if (response.status !== 200) {
                throw new Error( 'Problem! Status Code: ' + response.status );
            }

            return response.json();
        })
        .then(socialCounts => {
            const socialCountsList = JSON.parse(socialCounts);

            Object.keys(socialCountsList).forEach((value) => {

                console.log(value);
                console.log(socialCountsList[value]);

                if (socialCountsList[value] < 1) {
                    return;
                }

                switch (value) {
                    case 'fb':
                        $('.js-social-likes-counter__fb').append(socialCountsList[value]).show();
                        break;
                    case 'vk':
                        $('.js-social-likes-counter__vk').append(socialCountsList[value]).show();
                        break;
                }
            });
        })
        .catch(function(err) {
            console.log('Error: ', err);
        });
});

$('.js-social-likes__widget').click(event => {
    const socialName = $(event.currentTarget).find('.hh-social-likes__icon').attr('title').toLowerCase();
    const postId = HH.post_id;

    const data = new FormData();
    data.append('social_net', socialName);
    data.append('post_id', postId);

    fetch(HH.site_url + '/wp-json/hh/social-rest-api/v1/social-stats-add/', {
        method: 'POST',
        body: data,
    })
        .then(response => {
            if (response.status !== 200) {
                throw new Error( 'Problem! Status Code: ' + response.status );
            }

            return response.text()
        })
        .then((result) => {
            console.log('Social Click added');
        })
        .catch(function(err) {
            console.log('Error: ', err);
        });
});